import React from 'react';
import { Grid, Card as SemanticCard, Image, Loader, Modal, Feed } from 'semantic-ui-react';
import { StarRating, PlayButton } from '../';
import { config } from '../../config';
import './Card.css';

const Thumbnail = ({ show, onClick, videoSRC, thumbSRC }) => show && (
  <div className="thumbnail">
    {thumbSRC
      ? <div className="innerImg">
        <Modal
          style={{ padding: '0 !important', background: '#000' }}
          closeIcon
          closeOnEscape
          closeOnDimmerClick={false}
          dimmer="blurring"
          trigger={
            <div className="play-button">
              <PlayButton onClick={onClick} />
            </div>
          }
          content={
            <div className="content">
              <video className="videoPlugIn" width="560" height="315" controls autoPlay>
                <source
                  src={videoSRC}
                  type="video/mp4"
                />
              </video>
            </div>
          }
          className="videoModal"
        />

        <Image width="100%" size="large" src={thumbSRC} />
      </div>
      : <Loader indeterminate size='large' active>Processing Video...</Loader>
    }
  </div>
);

export const Card = ({ video, thumbSRC, index, onThumbnailClick }) => {
  const siteAssets = config.AWS.SiteAssets;

  const getDescriptionLength = ({ haveDescription, haveTitle, haveStartRating }) => {
    if (
      window.innerWidth <= 425 &&
      haveDescription &&
      haveTitle
    ) return 50;

    const MAX_RESPONSIVE_WIDTH = 991;
    return (
      (haveTitle && haveStartRating)
      || window.innerWidth <= MAX_RESPONSIVE_WIDTH) ? 50 : 100;
  }

  const MAX_DESCRIPTION_LENGTH = getDescriptionLength({
    haveDescription: video.videoDescription,
    haveTitle: video.videoTitle,
    haveStartRating: video.starRating,
  });

  const videoDescriptionLength = video.showText ? 480 : MAX_DESCRIPTION_LENGTH;
  const selfieBaseURL = `${siteAssets}/campaign/selfie_photo`;
  // TODO: Update after figure out aws pipeline
  // const selfieOtimized = `${selfieBaseURL}/optimized/${video.campaignId}/${video.selfie_photo.replace('.', '-100.')}`;
  const selfieOriginal = `${selfieBaseURL}/original/${video.campaignId}/${video.selfie_photo}`;
  const selfieOtimized = selfieOriginal;

  const hasNoTitleOrFullNameAndSelfie =
    (!!!video.userTitle || !!!video.fullName) && !!!video.selfie_photo;

  // Workaround to get the original selfie if the host is staging
  const selfie = window.location.host === 'plugin.videopeel.com'
    ? selfieOtimized
    : selfieOriginal;

  return (
    <Grid className={`carouselWrap ${hasNoTitleOrFullNameAndSelfie && 'one-title'}`}>
      <Grid.Row>
        <Grid.Column key={index} computer={16} tablet={16} mobile={16}>
          <SemanticCard>
            <Thumbnail
              show={!video.showText}
              onClick={onThumbnailClick}
              videoSRC={`${siteAssets}/${video.videoId}/${video.fileName}.mp4`}
              thumbSRC={thumbSRC}
            />

            <div className="carouselData">
              {video.videoTitle &&
                <p className="videoTitle">{video.videoTitle}</p>
              }

              {
                video.videoDescription && (video.videoDescription.length > MAX_DESCRIPTION_LENGTH)
                  ? <div>
                    <p className="videoDescription">
                      {video.videoDescription.slice(0, videoDescriptionLength)}...
                            <Modal
                        closeIcon
                        closeOnEscape={true}
                        closeOnDimmerClick={false}
                        dimmer="blurring"
                        trigger={<a className="blueLink" href="#">More</a>}
                        content={
                          <div className="content">
                            {video.videoTitle &&
                              <p className="videoTitle p-15">{video.videoTitle}</p>
                            }
                            <p className="videoDescription p-15">{video.videoDescription}</p>
                            <p className="p-15">
                              <Feed className={hasNoTitleOrFullNameAndSelfie && 'one-title'}>
                                <StarRating
                                  show={!!video.starRating}
                                  value={video.starRating}
                                />
                                <Feed.Event>
                                  {
                                    video.selfie_photo &&
                                    <span className="userInterface">
                                      <Image src={selfie} />
                                    </span>
                                  }
                                  <Feed.Content>
                                    <Feed.Summary>
                                      {video.fullName && <p className="fullName">{video.fullName}</p>}
                                      {video.userTitle && <p className="userTitle">{video.userTitle}</p>}
                                    </Feed.Summary>
                                  </Feed.Content>
                                </Feed.Event>
                              </Feed>
                            </p>
                          </div>
                        }
                      />
                    </p>
                  </div>
                  : <p className="videoDescription">{video.videoDescription}</p>
              }
              <Feed>
                <StarRating
                  show={!!video.starRating}
                  value={video.starRating}
                />
                <Feed.Event>
                  {
                    video.selfie_photo &&
                    <span className="userInterface">
                      <Image src={selfie} />
                    </span>
                  }
                  <Feed.Content>
                    <Feed.Summary>
                      {video.fullName && <p className="fullName">{video.fullName}</p>}
                      {video.userTitle && <p className="userTitle">{video.userTitle}</p>}
                    </Feed.Summary>
                  </Feed.Content>
                </Feed.Event>
              </Feed>
            </div>
          </SemanticCard>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}



// WEBPACK FOOTER //
// ./src/components/Card/Card.js